module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "service.7cab9b3c.svg";